const BookingService = {
  async saveBooking(formData) {
    try {
      let url = '/api/<your_controller>';
      let method = 'PUT';
      if (formData.identifier === undefined) {
        const profileLogged = JSON.parse(localStorage.getItem('profile'));
        const { accountIdentifier } = profileLogged;
        console.log(profileLogged);
        console.log(accountIdentifier);
        url = '/api/<your_controller>';
        method = 'POST';
      }

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        const newBooking = await response.json();
        console.log('Booking has been updated:', newBooking);
      }
    } catch (error) {
      console.log('Error saving Booking', error);
    }
  },
  async retrieveAllBookingByAccount() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch(
        '/api/<your_controller>' + accountIdentifier
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Booking', error);
      throw error;
    }
  },
  async retrieveAllBookingsByUser() {
    try {
      const profile = JSON.parse(localStorage.getItem('profile'));
      const response = await fetch(
        '/api/wod/wodclass/bookings/profile/' + profile.identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Booking', error);
      throw error;
    }
  },
  async retrieveUpcomingBookingsByUser() {
    try {
      const profile = JSON.parse(localStorage.getItem('profile'));
      const response = await fetch(
        '/api/wod/wodclass/bookings/profile/' + profile.identifier
      );
      const data = await response.json();
      const now = new Date();

      const upcomingBookings = data.filter(wodClass => {
        const [year, month, day] = wodClass.date;
        const [hour, minute, second = 0] = wodClass.startTime;
        const classDateTime = new Date(
          year,
          month - 1, // JS months are 0-based
          day,
          hour,
          minute,
          second
        );

        return classDateTime >= now;
      });
      console.log('Upcoming Bookings:', upcomingBookings);
      return upcomingBookings;
    } catch (error) {
      console.error('Error fetching Booking', error);
      throw error;
    }
  },
  async retrieveBooking(identifier) {
    try {
      const response = await fetch('/api/<your_controller>/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Booking', error);
      throw error;
    }
  },
  async deleteBooking(identifier) {
    const profile = JSON.parse(localStorage.getItem('profile'));
    try {
      const response = await fetch('/api/wod/wodclass/cancel/' + identifier + '/' + profile.identifier, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ identifier })
      });
      if (response.ok) {
        const result = await response.json();
        console.log('Booking has been deleted:', result);
      }
    } catch (error) {
      console.log('Error deleting Booking', error);
    }
  },
};
export default BookingService;
